// src/pages/ContentEditor/components/tabs/VocabularyTab.js
import React from 'react';
import { Box, Typography, Button, Card, CardContent, IconButton, TextField, Grid, alpha } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const VocabularyTab = ({ sentences, onNestedChange, onAddItem, onRemoveItem }) => {
  const theme = useTheme();
  
  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" color="text.primary">
          Vocabulary Sentences
        </Typography>
        
        <Button
          startIcon={<AddIcon />}
          onClick={onAddItem}
          sx={{ color: theme.palette.primary.main }}
        >
          Add Vocabulary Item
        </Button>
      </Box>
      
      {sentences.map((item, index) => (
        <Card 
          key={index} 
          variant="outlined" 
          sx={{ 
            mb: 3, 
            backgroundColor: theme.palette.background.paper,
            borderColor: alpha(theme.palette.common.white, 0.1),
            '&:hover': {
              borderColor: theme.palette.primary.main,
            }
          }}
        >
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="subtitle1" fontWeight={500} color="text.primary">
                Vocabulary Item {index + 1}
              </Typography>
              
              <IconButton 
                color="error" 
                onClick={() => onRemoveItem(index)}
                disabled={sentences.length <= 1}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
            
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Example Sentence"
                  variant="outlined"
                  placeholder="Enter a sentence using the vocabulary word..."
                  value={item.sentence.text}
                  onChange={(e) => onNestedChange('vocabularyActivity', index, 'sentence', e.target.value)}
                  InputLabelProps={{ style: { color: theme.palette.text.secondary } }}
                  InputProps={{ style: { color: theme.palette.text.primary } }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: alpha(theme.palette.common.white, 0.2),
                      },
                      '&:hover fieldset': {
                        borderColor: alpha(theme.palette.common.white, 0.3),
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: theme.palette.primary.main,
                      },
                      backgroundColor: alpha(theme.palette.common.white, 0.05)
                    }
                  }}
                />
              </Grid>
              

            </Grid>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default VocabularyTab;
